import { useMemo } from 'react';
import dayjs from 'dayjs';
import { DEFAULT_DATE_FORMAT } from 'src/constants';
import { EmptyState } from '../EmptyState';
import { SpinnerSimple } from 'src/v2/commonComponents/SpinnerSimple';
import { FileListGroupedByDate } from '../FileListGroupedByDate';
import { useGetEditorThreadsQuery } from 'src/store/services';
import { useGetUser } from 'src/hooks';
import styles from './FileList.module.scss';
import { SimpleThread } from 'src/types';
import { FileListUpsellMessage } from '../FileListUpsellMessage';

export const FileList = () => {
  const { user_id, isOpenTier } = useGetUser();

  const { data, isLoading } = useGetEditorThreadsQuery({ user_id });

  const groupedDocumentListByDate: Record<string, SimpleThread[]> =
    useMemo(() => {
      if (!data || data.threads.length === 0) {
        return {};
      }

      const { threads } = data;

      const groupedData: Record<string, SimpleThread[]> = {};

      for (const documentListItem of threads) {
        // TODO(olha): WIP Editor we should use updated_at when BE is ready
        const groupedDate = dayjs(documentListItem.created_at).format(
          DEFAULT_DATE_FORMAT,
        );

        if (!groupedData[groupedDate]) {
          groupedData[groupedDate] = [documentListItem];
        } else {
          groupedData[groupedDate] = [
            ...groupedData[groupedDate],
            documentListItem,
          ];
        }
      }

      return groupedData;
    }, [data]);

  const documentList = Object.entries(groupedDocumentListByDate);
  const shouldShowEmptyState =
    documentList.length === 0 && !isLoading && !isOpenTier;

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        {shouldShowEmptyState && <EmptyState />}

        {isOpenTier && <FileListUpsellMessage />}

        {isLoading && (
          <div className={styles.spinnerWrapper}>
            <SpinnerSimple />
          </div>
        )}

        {!isLoading && documentList.length > 0 && (
          <div className={styles.documents}>
            {documentList.map(([date, group]) => (
              <FileListGroupedByDate
                key={date}
                date={date}
                groupedDocuments={group}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
